import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSpinner = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  "aria-label": "loading spinner",
  fill: "none",
  focusable: "false",
  height: "1em",
  role: "img",
  viewBox: "0 0 20 20",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M17.2442 11.9405C18.3163 7.93947 15.9419 3.82695 11.9409 2.75488",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2.25"
})), "IcSpinner");

export { IcSpinner };
//# sourceMappingURL=ic-spinner.js.map
